import { toLower, upperCase, capitalize, keys } from 'lodash';
import { setSelected } from '../../../utils/filter/selection';
import { timePeriods } from '../../../utils/filter/index';
import { getYearFromUtc, formatDate } from '../../../utils/date';

const getRaceTypesOptions = seasonsAvailable => keys(seasonsAvailable).reduce(
    (result, key) => (seasonsAvailable[key] ? [
        ...result,
        { label: capitalize(key), value: toLower(key) },
    ] : result),
    []
);

const getOnwardsOption = (raceType, seasonsForType) => {
    const { seasonStartDate, seasonEndDate } = seasonsForType[seasonsForType.length - 1];
    const lastSeasonEndDate = seasonsForType[0].seasonEndDate;
    const jumpsSuffix = raceType === 'jumps' ? `-${formatDate(seasonEndDate, 'YY')}` : '';

    return {
        value: `${getYearFromUtc(seasonStartDate)}/${getYearFromUtc(lastSeasonEndDate)}`,
        label: `${formatDate(seasonStartDate, 'Y')}${jumpsSuffix} onwards`,
    };
};

export const timePeriodsFactory = (raceType, seasonsAvailable) => {
    const options = timePeriods.getAvailable(seasonsAvailable, upperCase(raceType));
    const seasonsForType = seasonsAvailable[upperCase(raceType)];
    if (seasonsForType.length > 1) {
        options.unshift(getOnwardsOption(raceType, seasonsForType));
    }
    options[0].selected = true;

    return {
        title: 'time period',
        options,
        createdBy: {
            raceType,
            seasonsAvailable,
        },
    };
};

const raceTypeFactory = (raceType, seasonsAvailable) => ({
    title: 'race type',
    options: setSelected(getRaceTypesOptions(seasonsAvailable), raceType),
});

const categoriesFactory = (seasonsAvailable, { raceType }) => ({
    raceType: raceTypeFactory(raceType, seasonsAvailable),
    timePeriod: timePeriodsFactory(raceType, seasonsAvailable),
});

export default categoriesFactory;



// WEBPACK FOOTER //
// ./src/js/horse/progeny/components/categories.js